import React, { useState } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { ShortcutScope } from '@atlassian/jira-common-components-keyboard-shortcuts';
import { UNLOCKED_STEP_ID } from './constants';
import { StepOne, StepTwo, StepThree, StepFour, StepFive } from './steps';
import type { WizardProps } from './types';

export const Wizard = ({ isOpen, onClose, defaultStep = 1, onUnlock }: WizardProps) => {
	const [currentStep, setCurrentStep] = useState(defaultStep);

	return (
		<ModalTransition>
			{isOpen && (
				<ShortcutScope>
					<Modal height={700} width={1100} onClose={onClose} shouldCloseOnOverlayClick={false}>
						{currentStep === 1 && <StepOne onAction={setCurrentStep} onClose={onClose} />}
						{currentStep === 2 && <StepTwo onAction={setCurrentStep} onClose={onClose} />}
						{currentStep === 3 && <StepThree onAction={setCurrentStep} onClose={onClose} />}
						{currentStep === 4 && (
							<StepFour onAction={setCurrentStep} onClose={onClose} onUnlock={onUnlock} />
						)}
						{currentStep === 5 && (
							<StepFive
								onClose={onClose}
								// If started from step 5, it means we weren't the one unlocking it
								isFirstUnlocked={defaultStep !== UNLOCKED_STEP_ID}
							/>
						)}
					</Modal>
				</ShortcutScope>
			)}
		</ModalTransition>
	);
};
